module.exports = __webpack_public_path__ + "img/logo2.9553a9ed.png";